"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILStudentCard = void 0;
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var user_config_1 = require("../../configs/user.config");
var enums_1 = require("../../shared/enums");
var il_icon_common_1 = require("../il-icon/il-icon.common");
var il_default_avatar_1 = require("./il-default-avatar");
function ILStudentCard(_a) {
    var color = _a.color, name = _a.name, _b = _a.showBadge, showBadge = _b === void 0 ? false : _b, children = _a.children, sx = _a.sx, className = _a.className, calendarAction = _a.calendarAction, _c = _a.showCalendarButton, showCalendarButton = _c === void 0 ? false : _c;
    var classes = 'il-student-card ' + className;
    var selectedColor = user_config_1.userConfig.color[color] || color;
    function onClickCalendar() {
        calendarAction && calendarAction();
    }
    return (react_1.default.createElement(material_1.Box, { className: classes, sx: __assign({ display: 'flex', flexDirection: 'row', maxHeight: 80, backgroundColor: 'background.default', borderTopLeftRadius: '16px', borderTopRightRadius: '16px', borderBottom: "2px solid ".concat(selectedColor), mt: 2, justifyContent: 'space-between', flexWrap: 'nowrap', maxWidth: '100%' }, sx) },
        react_1.default.createElement(material_1.Box, { sx: {
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'nowrap',
                gap: 1,
                width: "calc(100% - ".concat(showCalendarButton ? '45px' : '0px', ")"),
                maxWidth: '100%',
            } },
            react_1.default.createElement(material_1.Box, { sx: { mt: '-35px', maxHeight: 115 } },
                react_1.default.createElement(il_default_avatar_1.ILDefaultAvatar, { color: selectedColor })),
            react_1.default.createElement(material_1.Box, { sx: { py: { xs: 1.3, sm: 2 }, gap: 0.5, width: "calc(100% - 130px)", maxWidth: '100%' } },
                react_1.default.createElement(material_1.Typography, { sx: {
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        fontSize: { xs: '95%', sm: '1.375rem' },
                    }, variant: enums_1.TypographyVariantEnum.H3 }, name))),
        showCalendarButton && (react_1.default.createElement(material_1.Box, { sx: { pt: 1, px: 1 } },
            react_1.default.createElement(material_1.IconButton, { "aria-label": "Badge action", onClick: onClickCalendar },
                react_1.default.createElement(material_1.Badge, { sx: {
                        '& .MuiBadge-badge': {
                            height: { xs: '0.9rem', sm: '1rem' },
                            minWidth: { xs: '0.9rem', sm: '1rem' },
                        },
                    }, badgeContent: "", color: "error", invisible: !showBadge },
                    react_1.default.createElement(il_icon_common_1.RegularIcon, null))))),
        children));
}
exports.ILStudentCard = ILStudentCard;
